import React from 'react';
import Welcome from '../components/Welcome';
import { Box, IconArrowForward, Typography } from '@capitalise/ui-design-system';
import ImageTitleDescription from 'components/ImageTitleDescription';
import CreditScoreGuy from 'assets/svgs/credit-score-guy.svg';
import GrowFundingGirl from 'assets/svgs/grow-funding-girl.svg';
import AccountSetupImage from 'assets/svgs/account-setup.svg';
import HelpButton from '../components/HelpButton';

export default ({ completeOnboarding, setOpenQuestionnaire }) => [
  {
    label: 'Welcome',
    lead: 'Thank you for signing up. Let’s get you set-up and start impressing your clients with a better way to understand their business finances.',
    title: 'Hello!',
    component: Welcome,
    iconButton: null,
    nextButtonLabel: 'Continue to onboarding',
  },
  {
    lead: 'Get started in your practice with a powerful business finance partnership. Experian powered credit scores to help with pre-funding checks and monitoring financial health.',
    label: 'Insights',
    title: 'Insights and credit scores for your clients!',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: CreditScoreGuy,
    iconButton: IconArrowForward,
  },
  {
    lead: 'Help get your clients funding-ready by preparing their applications. Then submit - with our support - to over 100+ lenders through our marketplace to secure offers of finance for your clients.',
    label: 'Funding',
    title: 'Funding - made easy with specialist support',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: GrowFundingGirl,
    iconButton: IconArrowForward,
  },
  {
    label: 'All Set',
    title: 'Your account is set up!',
    lead: "You're ready to go!",
    component: ImageTitleDescription,
    hasPrevious: true,
    image: AccountSetupImage,
    iconButton: null,
    children: (
      <HelpButton
        helpLabel={
          <Box display="flex" flexDirection="column">
            <Typography size="heading-16" color="grey-900">
              Need to get funding for a client?
            </Typography>
            <Typography size="body-16" color="grey-900">
              Start a search right away
            </Typography>
          </Box>
        }
        buttonLabel="Start funding search"
        onClickCallback={() => {
          setOpenQuestionnaire(true);
        }}
      />
    ),
    nextButtonAction: () => {
      completeOnboarding();
    },
    nextButtonLabel: 'Go to dashboard',
  },
];
